var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGemeaux = function SvgGemeaux(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.91 78.01",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 67a68 68 0 0 0-2.26-10.23c-2-6.28-10-7.11-12-8.09s-2.49-4.31-2-5.67.36-2.57-.37-2.95-.29-1.21-.29-1.21l.73-1.21a3.4 3.4 0 0 0-1.17-1 .93.93 0 0 1-.37-1.21s.59-1.52.95-2.35-1.1-.9-2.57-1.89-.14-2.79 1.47-5.14c2.76-4 3.23-8.61 3.23-13.45S28 1.51 28 1.51L17.59 0l-7.34 1.51s-4.76 6.2-4.76 11S5 22 2.17 26C.5 28.35-.86 30.16.65 31.14S3.68 32.2 3.3 33s-1 2.35-1 2.35a.91.91 0 0 0 .38 1.21 3.4 3.4 0 0 1 1.2 1l-.75 1.21s-.45.83.3 1.21.83 1.59.38 2.95S3.9 47.7 6 48.68s10.28 1.81 12.32 8.09a65 65 0 0 1 2.25 9.79c-8.13.15-14.2.75-14.2 1.47v8.47c0 .83 8.19 1.51 18.3 1.51s18.29-.68 18.29-1.51V68c-.05-.37-1.9-.73-4.96-1",
    "data-name": "Calque 3",
    style: {
      fill: "#fff"
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGemeaux);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gemeaux.b7d142ae4584979fd08da8981c47e442.svg";